module.exports = __webpack_public_path__ + "img/c02.90eebe66.png";